import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Kadoobonnen from "./Kadoobonnen";
import { useLocation } from "react-router-dom";

import { BrowserRouter } from "react-router-dom";
import { PDF } from "./PDF";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

function Main() {
  const location = useLocation();

  if (location.search.includes("pdf")) {
    return <PDF />;
  } else {
    return <Kadoobonnen />;
  }
}
